import React from 'react';
import { Alert, Box, Chip, Stack, Typography } from '@mui/material';
import { formatCurrency, formatDate, toNumber } from '../paymentNormalizer';

const getStatusLabel = (status) => {
  if (status === 'P') return 'Pendiente';
  if (status === 'C') return 'Compensado';
  return status || 'N/D';
};

export default function PaymentAdjustmentsSection({ payment }) {
  const adjustments = Array.isArray(payment?.adjustments) ? payment.adjustments : [];
  const adjustmentTotal = adjustments.reduce((sum, item) => sum + toNumber(item.amount), 0);
  const totalFinal = toNumber(payment?.totalAmount);
  const baseAmount = Math.max(totalFinal - adjustmentTotal, 0);

  return (
    <Stack spacing={1.5}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Ajustes
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, minmax(0, 1fr))' },
          gap: 1,
        }}
      >
        {[
          { label: 'Monto base', value: baseAmount },
          { label: 'Ajustes', value: adjustmentTotal },
          { label: 'Total final', value: totalFinal },
        ].map((item) => (
          <Box
            key={item.label}
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              p: 1.25,
              bgcolor: 'background.paper',
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {item.label}
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
              {formatCurrency(item.value)}
            </Typography>
          </Box>
        ))}
      </Box>

      {adjustments.length === 0 ? (
        <Alert severity="info">Sin ajustes aplicados.</Alert>
      ) : (
        <Stack spacing={1}>
          {adjustments.map((item) => (
            <Box
              key={item.id || `${item.invoice_id}-${item.type}-${item.amount}`}
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 1.25,
                bgcolor: 'background.paper',
              }}
            >
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="space-between">
                <Box>
                  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      {item.type || 'Ajuste'}
                    </Typography>
                    <Chip size="small" label={getStatusLabel(item.status)} variant="outlined" />
                  </Stack>
                  <Typography variant="body2" color="text.secondary">
                    {[item.reason, item.created_at ? formatDate(item.created_at) : null].filter(Boolean).join(' - ')}
                  </Typography>
                </Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
                  {formatCurrency(item.amount)}
                </Typography>
              </Stack>
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
